var _ellipse, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "malaysia",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.03,
    height: 32.03,
    viewBox: "0 0 32.03 32.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 15.962,
    cy: 16.015,
    rx: 15.962,
    ry: 16.015,
    transform: "translate(0.107 0)",
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(0.543 3.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M244.87,193.342h16.446a15.88,15.88,0,0,0-.543-4.125h-15.9Z",
    transform: "translate(-230.337 -180.967)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M244.87,59.777H259a15.879,15.879,0,0,0-3.637-4.125h-10.5Z",
    transform: "translate(-230.337 -55.652)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M106.454,459.786a15.661,15.661,0,0,0,9.811-3.438H96.643A15.661,15.661,0,0,0,106.454,459.786Z",
    transform: "translate(-91.236 -431.597)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M10.589,326.907H37.484a15.747,15.747,0,0,0,1.77-4.125H8.819A15.745,15.745,0,0,0,10.589,326.907Z",
    transform: "translate(-8.819 -306.281)",
    fill: "#d80027"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M15.761,15.813V0A15.787,15.787,0,0,0,0,15.813Z",
    transform: "translate(0 0.309)",
    fill: "#0052b4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(4.185 5.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M74.269,86.637a3.91,3.91,0,1,1,1.854-7.351,4.813,4.813,0,1,0,0,6.881A3.871,3.871,0,0,1,74.269,86.637Z",
    transform: "translate(-67.973 -77.914)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M145.217,111.3l.692,1.452,1.563-.362-.7,1.448,1.257,1-1.565.354,0,1.609-1.251-1.007-1.251,1.007,0-1.609-1.565-.354,1.257-1-.7-1.448,1.563.362Z",
    transform: "translate(-137.823 -109.241)",
    fill: "#ffda44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.5fac04a33a374f82bfe6d031fffcb8b2.svg";
export { ForwardRef as ReactComponent };